import * as React from 'react';
import { AddUserTaskView } from 'src/app/general/user-tasks/parts/add-user-tasks.view';
import { UserTaskSummariesDataService } from 'src/app/general/user-tasks/list/user-task-list.data';


interface Props {
	setBusy(isBusy: boolean);
	kanban?: boolean;
	extraFilter?: (dataService: UserTaskSummariesDataService) => void;
}

export default class UserTasksFullPage extends React.Component<Props, any>{

	render() {
		return (
			<div className="window window-normal">
				<div className='panel card'>
					<h2>User tasks</h2>
					<AddUserTaskView {...this.props} useLoginFilter={false} />
				</div>
			</div>
		);
	}

}



// WEBPACK FOOTER //
// ./src/app/general/user-tasks/parts/user-tasks-fullpage.tsx